import { Injectable }             from '@angular/core';
import { CanActivate, Router,
         ActivatedRouteSnapshot,
         RouterStateSnapshot }    from '@angular/router';
import { AuthService }            from './auth.service';

import * as _ from 'lodash';


@Injectable()
export class AuthGuard implements CanActivate {

  systemDeveloperOnlyRoutes: string[] = ['/admin', '/user-admin'];

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    
    if (this.authService.isLoggedIn()) { 

        if( _.includes(this.systemDeveloperOnlyRoutes, state.url) && !this.authService.isInRole("System Developer")){
            this.router.navigate(['/welcome']);
            return false;
        }
        return true; 
    }
    else{
        // Store the attempted URL for redirecting
        this.authService.redirectUrl = state.url;
      
        // Navigate to the login page
        this.router.navigate(['/login', { requestedUrl: state.url}]);
      
        return false;
    }
  }
}


/** WEBPACK FOOTER **
 ** ./app/authentication/auth-guard.service.ts
 **/